import { createContext } from "react"
import type { TAuth } from "@/types"

export type AuthContextType = {
  auth: TAuth | null
  login: (auth: TAuth) => void
  logout: () => void
  refresh: () => void
}

export const AuthContext = createContext<AuthContextType | null>(null)
